function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#333333",
  points: "90.943,195.781 73.328,195.781 73.328,189.781 85.943,189.781 90.943,193.23 "
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#333333",
  points: "70.512,195.781 52.896,195.781 52.896,189.781 65.512,189.781 70.512,193.23 "
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#333333",
  points: "118.396,27.249 119.031,31.401 129.727,31.401 125.141,20.702 122.543,20.702 "
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 85.337,
  y: 50.972,
  fill: "#EE99CC",
  width: 8.889,
  height: 29.48
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#EE99CC",
  d: "M134.229,98.455h-0.117c-2.42,0-4.385-1.963-4.385-4.385V50.972h8.889l-0.004,43.099 C138.611,96.492,136.65,98.455,134.229,98.455"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#333333",
  points: "129.729,86.378 129.662,103.761 127.123,176.034 114.766,176.034 112.693,103.46 110.701,103.46  108.633,176.034 96.666,176.034 93.984,103.294 94.227,86.378 "
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M85.342,42.116v8.857h8.883v51.8h35.504v-51.8h8.881v-8.857c0-5.988-4.787-10.849-10.686-10.849H96.033 C90.127,31.268,85.342,36.128,85.342,42.116"
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 94.225,
  y: 31.268,
  fill: "#8244AD",
  width: 35.504,
  height: 71.503
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#EE99CC",
  points: "104.604,31.401 111.621,37.337 119.053,31.461 118.416,27.249 122.543,27.249 122.543,20.702  125.141,20.702 123.658,11.705 116.473,11.705 "
});

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#D5007F",
  points: "123.68,6.323 123.68,0 104.6,0 104.6,6.321 99.221,11.705 129.057,11.705 "
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#333333",
  points: "116.473,11.703 104.6,31.401 94.223,31.401 104.6,11.703 "
});

var _ref13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#333333",
  d: "M111.723,56.482c6.219,0,11.088-11.163,11.088-25.413h-1.615c0,12.901-4.34,23.801-9.473,23.801 c-5.139,0-9.479-10.768-9.479-23.515h-1.613C100.631,45.448,105.498,56.482,111.723,56.482"
});

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#EE99CC",
  d: "M176.957,99.933L176.957,99.933c-2.148,0-3.895-1.745-3.895-3.896v-9.241h7.791v9.241 C180.854,98.188,179.109,99.933,176.957,99.933"
});

var _ref15 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#E2E2E2",
  d: "M173.063,47.903v39.059h7.684h43.568V47.903c0-6.291-5.021-11.383-11.213-11.383h-28.824 C178.08,36.521,173.063,41.612,173.063,47.903"
});

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#EE99CC",
  d: "M182.705,26.595h2.725v6.87h4.332l-0.674,4.419l7.795,6.162l7.369-6.227v-5.807l-7.535-11.104h-5.598 c-1.215,0-2.189-0.977-2.189-2.181v-1.322h-4.736c-0.063,0.237-0.117,0.481-0.176,0.725L182.705,26.595z"
});

var _ref17 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#D5007F",
  d: "M205.496,17.41h-22.941c0,0-10.061-2.296-7.002-8.916C178.363,2.424,188.254,6.368,205.496,17.41"
});

var _ref18 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#333333",
  points: "187.943,0 200.273,0 204.223,17.41 183.994,17.41 "
});

var _ref19 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#CCCCCC",
  d: "M182.85,17.41h22.934c0,0,10.07-2.296,7.002-8.916C209.98,2.424,200.092,6.368,182.85,17.41"
});

var _ref20 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#333333",
  d: "M190.488,73.492h7.814c-0.262-0.491-0.641-1.34-0.857-2.432c-0.457-2.306,0.006-4.657,1.379-7.001 c5.838-10.017-0.1-17.309-0.355-17.615l-5.629,4.704c0.432,0.583,2.666,4.029-0.355,9.206 C189.438,65.586,189.607,70.223,190.488,73.492"
});

var _ref21 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#D5007F",
  d: "M192.035,48.796c0,2.623,2.123,4.747,4.748,4.747c2.623,0,4.75-2.124,4.75-4.747 c0-2.625-2.127-4.75-4.75-4.75C194.158,44.046,192.035,46.171,192.035,48.796"
});

var _ref22 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#333333",
  d: "M206.518,53.786c0,0.908,0.736,1.65,1.648,1.65c0.906,0,1.646-0.742,1.646-1.65 c0-0.909-0.74-1.643-1.646-1.643C207.254,52.144,206.518,52.877,206.518,53.786"
});

var _ref23 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#333333",
  d: "M188.93,17.406v1.324c0,1.202,0.977,2.181,2.189,2.181h5.6l7.533,11.1V17.406H188.93z"
});

var _ref24 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#EE99CC",
  d: "M194.932,22.032c0,1.41,1.141,2.553,2.547,2.553c1.414,0,2.557-1.143,2.557-2.553 c0-1.408-1.143-2.551-2.557-2.551C196.072,19.481,194.932,20.624,194.932,22.032"
});

var _ref25 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#333333",
  points: "219.723,86.796 219.723,98.019 215.553,176.034 203.111,176.034 201.025,107.915 199.02,107.915  196.936,176.034 184.025,176.034 180.715,97.758 180.715,86.796 "
});

var _ref26 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#EE99CC",
  d: "M92.756,113.567L92.756,113.567c2.152,0,3.898-1.746,3.898-3.894v-9.243h-7.787v9.243 C88.867,111.821,90.607,113.567,92.756,113.567"
});

var _ref27 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#E2E2E2",
  d: "M96.654,61.372c0-6.291-5.018-11.385-11.215-11.385H56.617c-6.191,0-11.213,5.094-11.213,11.385v41.126 l7.49,89.513h13.711l2.301-70.194h2.209l2.297,70.194h13.281l4.598-72.473v-17.04h5.363V61.372z"
});

var _ref28 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#EE99CC",
  d: "M64.008,46.23c0,0,0-11.505,0-18.586c0-13.808,16.236-13.986,19.287-0.182l1.254,8.072h-2.6v6.544h-4.123 l0.637,4.214l-7.434,5.87L64.008,46.23z"
});

var _ref29 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#EDEDED",
  points: "91.137,29.706 55.271,29.706 62.85,23.619 62.975,23.52 83.43,23.52 83.443,23.531 "
});

var _ref30 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#CCCCCC",
  d: "M83.547,23.613l-0.104-0.082l-0.016-0.012H62.977l-0.127,0.1l-0.098,0.078 c0.025-0.255,0.055-0.499,0.098-0.748c0.83-4.938,5.129-8.711,10.311-8.711c5.141,0,9.416,3.724,10.283,8.619 C83.486,23.104,83.523,23.358,83.547,23.613"
});

var _ref31 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#D5007F",
  d: "M70.512,64.032h0.006l-0.063,0.091l-0.008,0.015l-4.223,6.051l-0.322-7.568l-0.006-0.082 c-0.006-0.25,0.029-0.501,0.104-0.757c0.4-1.365,1.82-2.146,3.184-1.749c1.359,0.396,2.145,1.819,1.744,3.186 C70.838,63.522,70.693,63.795,70.512,64.032"
});

var _ref32 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#D5007F",
  d: "M71.547,64.032h-0.002l0.061,0.091l0.01,0.015l4.225,6.051l0.32-7.568l0.004-0.082 c0.006-0.25-0.027-0.501-0.104-0.757c-0.396-1.365-1.818-2.146-3.182-1.749c-1.357,0.396-2.143,1.819-1.74,3.186 C71.225,63.522,71.369,63.795,71.547,64.032"
});

var _ref33 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#D5007F",
  d: "M81.854,43.819v-0.003H78.09l0.373,2.476c-1.076,0.898-7.432,5.871-7.432,5.871s-6.021-5.036-7.023-5.931 h0.002h-0.002v-2.416H59.93c-1.898-0.082-2.889,1.651-2.889,2.634v3.304l13.988,13.372l13.984-13.372V46.45 C85.014,45.284,83.723,43.697,81.854,43.819"
});

var _ref34 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#333333",
  points: "73.596,29.706 64.008,39.837 64.008,29.706 "
});

var _ref35 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#D5007F",
  d: "M58.193,44.908l-1.26-1.007c0.088-0.113,2.188-2.889-0.072-6.832c-1.854-3.237-1.291-5.885-0.648-7.361 h1.801c-0.48,0.795-1.637,3.268,0.25,6.561C61.08,41.197,58.32,44.763,58.193,44.908"
});

var _ref36 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#409AA1",
  d: "M68.459,44.908l-1.256-1.007c0.086-0.113,2.191-2.889-0.068-6.832c-1.857-3.237-1.293-5.885-0.652-7.361 h1.799c-0.479,0.795-1.639,3.268,0.25,6.561C71.35,41.197,68.58,44.763,68.459,44.908"
});

var _ref37 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#333333",
  d: "M78.73,44.908l-1.262-1.007c0.092-0.113,2.186-2.889-0.072-6.832c-1.854-3.237-1.291-5.885-0.652-7.361 h1.809c-0.48,0.795-1.641,3.268,0.246,6.561C81.621,41.197,78.85,44.763,78.73,44.908"
});

var _ref38 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#D5007F",
  d: "M89,44.908l-1.264-1.007c0.094-0.113,2.189-2.889-0.07-6.832c-1.855-3.237-1.289-5.885-0.652-7.361h1.805 c-0.482,0.795-1.637,3.268,0.25,6.561C91.889,41.197,89.119,44.763,89,44.908"
});

var _ref39 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#D5007F",
  d: "M219.957,23.394c0,0,0.354,6.313,9.795,6.313v-4.491L219.957,23.394z"
});

var _ref40 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M216.824,54.516l-1.49,9.052h8.883v63.753h35.506V63.567h8.881l-1.391-9.592 c-0.664-6.004-3.4-10.113-9.301-10.113h-31.889C220.117,43.862,218.168,48.528,216.824,54.516"
});

var _ref41 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 224.219,
  y: 43.862,
  fill: "#D5007F",
  width: 35.504,
  height: 63.575
});

var _ref42 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#EE99CC",
  d: "M231.611,43.862v4.797c0.023,5.613,4.572,10.155,10.199,10.155c5.613,0,10.168-4.542,10.193-10.155v-4.797 H231.611z"
});

var _ref43 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#EE99CC",
  points: "268.516,95.503 268.604,63.567 259.723,63.567 259.723,95.503 "
});

var _ref44 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#EE99CC",
  d: "M219.715,111.052h0.119c2.422,0,4.385-1.965,4.385-4.384V63.567h-8.885v43.101 C215.334,109.087,217.295,111.052,219.715,111.052"
});

var _ref45 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#EE99CC",
  d: "M248.795,39.099v4.845L234.346,44l0.635-4.211h-4.123v-6.548h-2.602l1.254-8.065 c0.141-0.636,0.311-1.232,0.506-1.784h3.896l6.725,4.178L248.795,39.099z"
});

var _ref46 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#D5007F",
  d: "M228.412,23.394h20.422l-0.037-0.178C247.15,10.423,229.721,10.702,228.412,23.394"
});

var _ref47 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#F9DBED",
  d: "M228.203,23.394h-8.246c0,0,7.639,7.997,12.973,0H228.203z"
});

var _ref48 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#333333",
  points: "233.912,23.394 233.912,27.569 240.635,27.569 248.797,39.103 248.836,23.394 "
});

var _ref49 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#EE99CC",
  d: "M243.021,27.53c0,1.239-1.008,2.246-2.246,2.246c-1.242,0-2.248-1.007-2.248-2.246 c0-1.238,1.006-2.246,2.248-2.246C242.014,25.284,243.021,26.292,243.021,27.53"
});

var _ref50 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#F9B233",
  d: "M243.936,68.59c5.12-2.3,8.865-12.425,8.865-24.929h-1.611c0,12.904-4.34,23.805-9.479,23.805 c-5.135,0-9.475-10.766-9.475-23.514h-1.613c0,12.354,3.743,22.36,8.856,24.64c-1.799,0.844-3.054,2.66-3.054,4.779 c0,2.921,2.367,5.285,5.281,5.285c2.922,0,5.293-2.364,5.293-5.285C247,71.25,245.74,69.432,243.936,68.59z"
});

var _ref51 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#333333",
  points: "224.217,100.125 224.217,117.306 226.551,189.781 238.908,189.781 240.979,117.207 242.971,117.207  245.041,189.781 257.01,189.781 259.688,117.04 259.688,100.125 "
});

var _ref52 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#409AA1",
  d: "M306.629,75.104c-0.02-0.04-0.039-0.081-0.039-0.123c-0.064-0.27-0.146-0.556-0.23-0.827 c-0.102-0.352-0.186-0.721-0.287-1.113c-0.783-2.789-1.715-5.521-2.814-8.105c0-0.018-0.018-0.041-0.018-0.059 c-4.605-9.47-10.973-10.13-10.973-10.13l-10.336-8.536l0.161,6.406c0,0-6.663,4.317-4.804,2.876 c-9.236,1.145-13.441,9.807-13.441,9.807s-5.703,7.619-6.943,15.614c-1.24,7.997-2.047,33.342-2.047,33.342l-0.885,9.773h11.104 L266.684,206h31.064l1.631-83.148l10.893,0.055C310.271,122.906,310.994,92.218,306.629,75.104z"
});

var _ref53 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#EE99CC",
  d: "M283.594,69.478c0,0-0.969,0.14-1.473,0.14c-4.357,0-7.893-3.534-7.893-7.894 c0-2.537,1.201-4.791,3.059-6.231c-0.051,0.009-0.107,0.017-0.156,0.019l0.271-0.186c0,0,2.432-0.633,2.432-3.524v-4.509h-6.416 V42.99h-3.4l1.615-11.298h11.961V69.478z"
});

var _ref54 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#333333",
  d: "M292.268,38.709v61.921l-8.951-0.081h-1.01l-0.375-54.339v-8.392c0,0,0.352-6.115-4.834-6.115h-5.459 c0,0,1.117-8.763,8.867-8.763C289.041,22.94,292.268,32.405,292.268,38.709"
});

var _ref55 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#FFCACC",
  d: "M56.688,64.319v10.867h-9.51v37.604l-37.684,0.618V75.187H0V64.859c0-6.157,6.152-11.687,12.305-11.687 h33.242C51.703,53.173,56.688,58.165,56.688,64.319"
});

var _ref56 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#EE99CC",
  d: "M22.047,54.966c0,0,0-11.782,0-19.035c0-14.143,16.627-14.324,19.75-0.184l1.285,8.263H40.42v6.702h-4.223 l0.65,4.315l-7.611,6.016L22.047,54.966z"
});

var _ref57 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#EE99CC",
  d: "M47.176,75.187v43.889c0,2.639,2.139,4.753,4.754,4.753c2.641,0,4.758-2.114,4.758-4.753V75.187H47.176z"
});

var _ref58 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#EE99CC",
  d: "M0,75.187v43.889c0,2.639,2.139,4.753,4.754,4.753c2.639,0,4.76-2.114,4.76-4.753V75.187H0z"
});

var _ref59 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#333333",
  d: "M41.607,34.972H30.533v5.968l-8.486,12.233c0,0-11.438-0.777-11.438-10.764c0,0,8.449,3.048,8.449-4.494 c0-7.533,2.752-13.593,11.84-13.593C39.994,24.322,41.607,33.071,41.607,34.972"
});

var _ref60 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#EE99CC",
  d: "M31.814,40.801c0,1.291-1.041,2.331-2.336,2.331c-1.289,0-2.338-1.04-2.338-2.331s1.049-2.34,2.338-2.34 C30.773,38.461,31.814,39.51,31.814,40.801"
});

var _ref61 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#D5007F",
  points: "9.494,112.791 9.494,129.497 13.523,200 25.543,200 27.559,129.41 29.494,129.41 31.51,200  43.15,200 47.176,129.247 47.176,112.791 "
});

var _ref62 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#4E2627",
  points: "178.32,182.034 196.936,182.034 196.936,176.034 187.32,176.034 178.32,178.483 "
});

var _ref63 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#12373C",
  d: "M133.377,182.034h-9.443c0,0-0.586-1-1.293-1s-1.178,1-1.178,1h-6.703v-6h9.617l9,2.449V182.034z"
});

var _ref64 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#12373C",
  d: "M115.279,182.034h-9.441c0,0-0.586-1-1.293-1s-1.178,1-1.178,1h-6.703v-6h9.615l9,2.449V182.034z"
});

var _ref65 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#12373C",
  points: "48.113,206 40.67,206 34.377,203 33.199,206 31.496,206 31.496,200 41.113,200 49.113,204.449 "
});

var _ref66 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#12373C",
  points: "30.152,206 22.711,206 16.418,203 15.24,206 13.537,206 13.537,200 23.152,200 31.152,204.449 "
});

var _ref67 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#4E2627",
  points: "196.936,182.034 215.553,182.034 215.553,176.034 205.936,176.034 196.936,178.483 "
});

var _ref68 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#333333",
  points: "239.416,195.781 257.033,195.781 257.033,189.781 247.416,189.781 239.416,193.23 "
});

var _ref69 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#333333",
  points: "221.25,195.781 238.865,195.781 238.865,189.781 229.25,189.781 221.25,193.23 "
});

var _ref70 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 120.666,
  y: 96,
  fill: "#F9DBED",
  width: 48.865,
  height: 53.173
});

var _ref71 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 127.854,
  y: 105.343,
  fill: "#92C5C9",
  width: 34.492,
  height: 34.492
});

var _ref72 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 169.531,
  y: 96,
  fill: "#E76DB6",
  width: 20.119,
  height: 53.173
});

var _ref73 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#C8E2E4",
  points: "127.854,139.835 136.475,139.835 162.346,105.343 153.723,105.343 "
});

var _ref74 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#ADD4D7",
  points: "136.475,139.835 145.098,139.835 162.346,116.839 162.346,105.343 "
});

var _ref75 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#77B7BC",
  points: "145.098,139.835 153.723,139.835 162.346,128.337 162.346,116.839 "
});

var _ref76 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 165.219,
  y: 149.173,
  fill: "#B66464",
  width: 4.313,
  height: 56.827
});

var _ref77 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 112.045,
  y: 149.173,
  fill: "#B66464",
  width: 4.311,
  height: 56.827
});

var _ref78 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 193.963,
  y: 149.173,
  fill: "#B66464",
  width: 4.311,
  height: 56.827
});

var _ref79 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 112.045,
  y: 149.173,
  fill: "#9B4B4E",
  width: 86.229,
  height: 10.061
});

var SvgQueEsObs05 = function SvgQueEsObs05(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "311px",
    height: "206px",
    viewBox: "0 0 311 206",
    enableBackground: "new 0 0 311 206",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQueEsObs05, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/queEsObs_05.7e6854e4.svg";
export { ForwardRef as ReactComponent };